export default (editor, opts = {}) => {
  const domc = editor.DomComponents;

  domc.addType('MY-COMPONENT', {
    model: {
      defaults: {
        // Default props
      },
    },
    view: {

    },
  });


  domc.addType('Flexrow', {
    isComponent: el => el.className == "flexrow",
    model: {
      defaults: {
        // Default props
      },
    },
    view: {

    },
  });

  domc.addType('Flexcolumn', {
    isComponent: el => el.className == "flexcolumn",
    model: {
      defaults: {
        // Default props
      },
    },
    view: {

    },
  });

  domc.addType('Flexbox', {
    isComponent: el => el.className == "flexbox",
    model: {
      defaults: {
        // Default props
      },
    },
    view: {

    },
  });



  domc.addType('CTATAudioButton', {
    isComponent: el => el.className == "CTATAudioButton",
    model: {
      defaults: {
        traits: [
          // Strings are automatically converted to text types
          'id',
          'data-ctat-src',
          {
            type: 'select', // Type of the trait
            label: 'Enabled', // The label you will see in Settings
            name: 'data-ctat-enabled', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'select', // Type of the trait
            label: 'Tutored', // The label you will see in Settings
            name: 'data-ctat-tutored', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'select', // Type of the trait
            label: 'Show Feedback', // The label you will see in Settings
            name: 'data-ctat-show-feedback', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          }, {
            type: 'select', // Type of the trait
            label: 'Disable on Correct', // The label you will see in Settings
            name: 'data-ctat-disable-on-correct', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'select', // Type of the trait
            label: 'Show Feedback', // The label you will see in Settings
            name: 'data-ctat-show-hint-highlight', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
        ],
      },
    },
  });

  domc.addType('CTATButton', {
    isComponent: el => el.className == "CTATButton",
    model: {
      defaults: {
        traits: [
          // Strings are automatically converted to text types
          'id',
          {
            type: 'select', // Type of the trait
            label: 'Enabled', // The label you will see in Settings
            name: 'data-ctat-enabled', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'select', // Type of the trait
            label: 'Tutored', // The label you will see in Settings
            name: 'data-ctat-tutored', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'select', // Type of the trait
            label: 'Show Feedback', // The label you will see in Settings
            name: 'data-ctat-show-feedback', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          }, {
            type: 'select', // Type of the trait
            label: 'Disable on Correct', // The label you will see in Settings
            name: 'data-ctat-disable-on-correct', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'select', // Type of the trait
            label: 'Show Feedback', // The label you will see in Settings
            name: 'data-ctat-show-hint-highlight', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'text',
            name: 'value',
            placeholder: '-1',
          },          
        ],
      },
    },
  });

  domc.addType('CTATCheckBox', {
    isComponent: el => el.className == "CTATCheckBox",
    model: {
      defaults: {
        traits: [
          // Strings are automatically converted to text types
          'id',
          'name',
          {
            type: 'select', // Type of the trait
            label: 'Enabled', // The label you will see in Settings
            name: 'data-ctat-enabled', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'select', // Type of the trait
            label: 'Tutored', // The label you will see in Settings
            name: 'data-ctat-tutored', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'select', // Type of the trait
            label: 'Show Feedback', // The label you will see in Settings
            name: 'data-ctat-show-feedback', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          }, {
            type: 'select', // Type of the trait
            label: 'Disable on Correct', // The label you will see in Settings
            name: 'data-ctat-disable-on-correct', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'select', // Type of the trait
            label: 'Show Hint', // The label you will see in Settings
            name: 'data-ctat-show-hint-highlight', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          }       
        ],
      },
    },
  });


  domc.addType('CTATComboBox', {
    isComponent: el => el.className == "CTATComboBox",
    model: {
      defaults: {
        traits: [
          // Strings are automatically converted to text types
          'id',
          {type: 'text',
          name: 'data-ctat-labels',
          label: "Options"},
          {
            type: 'select', // Type of the trait
            label: 'Enabled', // The label you will see in Settings
            name: 'data-ctat-enabled', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'select', // Type of the trait
            label: 'Tutored', // The label you will see in Settings
            name: 'data-ctat-tutored', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'select', // Type of the trait
            label: 'Show Feedback', // The label you will see in Settings
            name: 'data-ctat-show-feedback', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          }, {
            type: 'select', // Type of the trait
            label: 'Disable on Correct', // The label you will see in Settings
            name: 'data-ctat-disable-on-correct', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'select', // Type of the trait
            label: 'Show Feedback', // The label you will see in Settings
            name: 'data-ctat-show-hint-highlight', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
        ],
        // As by default, traits are binded to attributes, so to define
        // their initial value we can use attributes
        attributes: {
          type: 'text',
          required: true
        },
      },
    },
  });


  domc.addType('CTATDoneButton', {
    isComponent: el => el.className == "CTATDoneButton",
    model: {
      defaults: {
        traits: [
          // Strings are automatically converted to text types
          {
            type: 'select', // Type of the trait
            label: 'Enabled', // The label you will see in Settings
            name: 'data-ctat-enabled', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'select', // Type of the trait
            label: 'Show Hint', // The label you will see in Settings
            name: 'data-ctat-show-hint-highlight', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          }       
        ],
      },
    },
  });

 
  
  domc.addType('CTATDragNDrop', {
    isComponent: el => el.className == "CTATDragNDrop",
    model: {
      defaults: {
        traits: [
          // Strings are automatically converted to text types
          'id',
          'name',
          {
            type: 'select', // Type of the trait
            label: 'Enabled', // The label you will see in Settings
            name: 'data-ctat-enabled', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'select', // Type of the trait
            label: 'Tutored', // The label you will see in Settings
            name: 'data-ctat-tutored', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'select', // Type of the trait
            label: 'Show Feedback', // The label you will see in Settings
            name: 'data-ctat-show-feedback', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          }, {
            type: 'select', // Type of the trait
            label: 'Disable on Correct', // The label you will see in Settings
            name: 'data-ctat-disable-on-correct', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'select', // Type of the trait
            label: 'Show Hint', // The label you will see in Settings
            name: 'data-ctat-show-hint-highlight', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'text',
            name: 'data-ctat-max-cardinality',
            label:'Max # of Items',
            placeholder: 'infinity',
          },
        ],
      },
    },
  });



  domc.addType('CTATFractionBar', {
    isComponent: el => el.className == "CTATFractionBar",
    model: {
      defaults: {
        traits: [
          // Strings are automatically converted to text types
          'id',
          {
            type: 'select', // Type of the trait
            label: 'Enabled', // The label you will see in Settings
            name: 'data-ctat-enabled', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'select', // Type of the trait
            label: 'Tutored', // The label you will see in Settings
            name: 'data-ctat-tutored', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'select', // Type of the trait
            label: 'Show Feedback', // The label you will see in Settings
            name: 'data-ctat-show-feedback', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          }, {
            type: 'select', // Type of the trait
            label: 'Disable on Correct', // The label you will see in Settings
            name: 'data-ctat-disable-on-correct', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'select', // Type of the trait
            label: 'Show Hint', // The label you will see in Settings
            name: 'data-ctat-show-hint-highlight', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'text',
            name: 'data-ctat-value',
            label:'Value',
            placeholder: '1/2+1/4+(0*1/8)',
          },
        ],
      },
    },
  });


  domc.addType('CTATGroupingComponent', {
    isComponent: el => el.className == "CTATGroupingComponent",
    model: {
      defaults: {
        traits: [
          // Strings are automatically converted to text types
          'id',
          {
            type: 'text',
            name: 'data-ctat-componentlist',
            label:'Component List',
            placeholder: 'CTAT component ids',
          },
        ],
      },
    },
  });


  domc.addType('CTATHintButton', {
    isComponent: el => el.className == "CTATHintButton",
    model: {
      defaults: {
        traits: [
          // Strings are automatically converted to text types
          'id',
          {
            type: 'select', // Type of the trait
            label: 'Enabled', // The label you will see in Settings
            name: 'data-ctat-enabled', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
        ],
      },
    },
  });

  domc.addType('CTATHintWindow', {
    isComponent: el => el.className == "CTATHintWindow",
    model: {
      defaults: {
        traits: [
          // Strings are automatically converted to text types
          'id'
        ],
      },
    },
  });

  domc.addType('CTATImageButton', {
    isComponent: el => el.className == "CTATImageButton",
    model: {
      defaults: {
        traits: [
          // Strings are automatically converted to text types
          'id',
          {
            type: 'select', // Type of the trait
            label: 'Enabled', // The label you will see in Settings
            name: 'data-ctat-enabled', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'select', // Type of the trait
            label: 'Tutored', // The label you will see in Settings
            name: 'data-ctat-tutored', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'select', // Type of the trait
            label: 'Show Feedback', // The label you will see in Settings
            name: 'data-ctat-show-feedback', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          }, {
            type: 'select', // Type of the trait
            label: 'Disable on Correct', // The label you will see in Settings
            name: 'data-ctat-disable-on-correct', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'select', // Type of the trait
            label: 'Show Feedback', // The label you will see in Settings
            name: 'data-ctat-show-hint-highlight', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'text',
            name: 'value',
            placeholder: '-1',
          },
          'data-ctat-image-default',
          'data-ctat-image-clicked',
          'data-ctat-image-hover',
          'data-ctat-image-disabled',
        ],
      },
    },
  });

  domc.addType('CTATJumble', {
    isComponent: el => el.className == "CTATJumble",
    model: {
      defaults: {
        traits: [
          // Strings are automatically converted to text types
          'id',
          {
            type: 'select', // Type of the trait
            label: 'Enabled', // The label you will see in Settings
            name: 'data-ctat-enabled', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'select', // Type of the trait
            label: 'Tutored', // The label you will see in Settings
            name: 'data-ctat-tutored', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'select', // Type of the trait
            label: 'Show Feedback', // The label you will see in Settings
            name: 'data-ctat-show-feedback', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          }, {
            type: 'select', // Type of the trait
            label: 'Disable on Correct', // The label you will see in Settings
            name: 'data-ctat-disable-on-correct', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'select', // Type of the trait
            label: 'Show Hint', // The label you will see in Settings
            name: 'data-ctat-show-hint-highlight', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          }       
        ],
      },
    },
  });

  domc.addType('CTATNumberLine', {
    isComponent: el => el.className == "CTATNumberLine",
    model: {
      defaults: {
        traits: [
          // Strings are automatically converted to text types
          'id',
          {
            type: 'select', // Type of the trait
            label: 'Enabled', // The label you will see in Settings
            name: 'data-ctat-enabled', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'select', // Type of the trait
            label: 'Tutored', // The label you will see in Settings
            name: 'data-ctat-tutored', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'select', // Type of the trait
            label: 'Show Feedback', // The label you will see in Settings
            name: 'data-ctat-show-feedback', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          }, {
            type: 'select', // Type of the trait
            label: 'Disable on Correct', // The label you will see in Settings
            name: 'data-ctat-disable-on-correct', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'select', // Type of the trait
            label: 'Show Hint', // The label you will see in Settings
            name: 'data-ctat-show-hint-highlight', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'text',
            name: 'data-ctat-maximum',
            label: "Max Value",
            placeholder: '3',
          },  
          {
            type: 'text',
            name: 'data-ctat-minimum',
            label: "Min Value",
            placeholder: '0',
          },    
          {
            type: 'text',
            name: 'data-ctat-large-tick-step',
            label: "Large Increment",
            placeholder: '1',
          },  
          {
            type: 'text',
            name: 'data-ctat-small-tick-step',
            label: "Small Increment",
            placeholder: '1/2',
          }, 
          {
            type: 'text',
            name: 'data-ctat-denominator',
            label: "Denominator",
            placeholder: '0',
          }, 
          {
            type: 'text',
            name: 'data-ctat-max-points',
            label: "Number of Points",
            placeholder: '1',
          }, 
          {
            type: 'text',
            name: 'data-ctat-point-size',
            label: "Point Size",
            placeholder: '7',
          }, 
          {
            type: 'select', // Type of the trait
            label: 'Snap to Tick Marks', // The label you will see in Settings
            name: 'data-ctat-snap', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'text',
            name: 'data-ctat-rotation',
            label: "Angle",
            placeholder: '0',
          }, 
          {
            type: 'text',
            name: 'data-ctat-ctrl-max',
            label: "Max Val Ctrls",
          }, 
          {
            type: 'text',
            name: 'data-ctat-ctrl-min',
            label: "Min Val Ctrls",
          }, 
          {
            type: 'text',
            name: 'data-ctat-ctrl-large-tick',
            label: "Large Tick Ctrls",
          }, 
          {
            type: 'text',
            name: 'data-ctat-ctrl-small-tick',
            label: "Small Tick Ctrls",
          }, 
          {
            type: 'text',
            name: 'data-ctat-ctrl-denominator',
            label: "Denominator Ctrls",
          }, 
        ],
      },
    },
  });

  domc.addType('CTATNumericStepper', {
    isComponent: el => el.className == "CTATNumericStepper",
    model: {
      defaults: {
        traits: [
          // Strings are automatically converted to text types
          'id',
          {
            type: 'select', // Type of the trait
            label: 'Enabled', // The label you will see in Settings
            name: 'data-ctat-enabled', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'select', // Type of the trait
            label: 'Tutored', // The label you will see in Settings
            name: 'data-ctat-tutored', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'select', // Type of the trait
            label: 'Show Feedback', // The label you will see in Settings
            name: 'data-ctat-show-feedback', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          }, {
            type: 'select', // Type of the trait
            label: 'Disable on Correct', // The label you will see in Settings
            name: 'data-ctat-disable-on-correct', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'select', // Type of the trait
            label: 'Show Hint', // The label you will see in Settings
            name: 'data-ctat-show-hint-highlight', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'text',
            name: 'value',
            label: "Init Value",
          }, 
          {
            type: 'text',
            name: 'max',
            label: "Max Value",
          }, 
          {
            type: 'text',
            name: 'min',
            label: "Min Value",
          }, 
          {
            type: 'text',
            name: 'step',
            label: "Step Value",
          }, 
        ],
      },
    },
  });

  domc.addType('CTATPieChart', {
    isComponent: el => el.className == "CTATPieChart",
    model: {
      defaults: {
        traits: [
          // Strings are automatically converted to text types
          'id',
          {
            type: 'select', // Type of the trait
            label: 'Enabled', // The label you will see in Settings
            name: 'data-ctat-enabled', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'select', // Type of the trait
            label: 'Tutored', // The label you will see in Settings
            name: 'data-ctat-tutored', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'select', // Type of the trait
            label: 'Show Feedback', // The label you will see in Settings
            name: 'data-ctat-show-feedback', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          }, {
            type: 'select', // Type of the trait
            label: 'Disable on Correct', // The label you will see in Settings
            name: 'data-ctat-disable-on-correct', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'select', // Type of the trait
            label: 'Show Hint', // The label you will see in Settings
            name: 'data-ctat-show-hint-highlight', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'text',
            name: 'data-ctat-value',
            label:'Value',
            placeholder: '1/2+1/4+(0*1/8)',
          },
          {
            type: 'text',
            name: 'data-ctat-ctrl-denominator',
            label: "Denominator Ctrls",
          }, 
          {
            type: 'text',
            name: 'data-ctat-ctrl-numerator',
            label: "Numerator Ctrls",
          }, 
          {
            type: 'text',
            name: 'data-ctat-ctrl-partition',
            label: "Partition Ctrls",
          }, 
          {
            type: 'text',
            name: 'data-ctat-explode',
            label: "Seperate Distance",
            placeholder: "3"
          }, 
          {
            type: 'text',
            name: 'data-ctat-shadow-distance',
            label: "Shadow Length",
            placeholder: "3"
          }, 
        ],
      },
    },
  });

  domc.addType('CTATRadioButton', {
    isComponent: el => el.className == "CTATRadioButton",
    model: {
      defaults: {
        traits: [
          // Strings are automatically converted to text types
          'id',
          'name',
          {
            type: 'select', // Type of the trait
            label: 'Enabled', // The label you will see in Settings
            name: 'data-ctat-enabled', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'select', // Type of the trait
            label: 'Tutored', // The label you will see in Settings
            name: 'data-ctat-tutored', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'select', // Type of the trait
            label: 'Show Feedback', // The label you will see in Settings
            name: 'data-ctat-show-feedback', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          }, {
            type: 'select', // Type of the trait
            label: 'Disable on Correct', // The label you will see in Settings
            name: 'data-ctat-disable-on-correct', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'select', // Type of the trait
            label: 'Show Hint', // The label you will see in Settings
            name: 'data-ctat-show-hint-highlight', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          }       
        ],
      },
    },
  });

  domc.addType('CTATSkillWindow', {
    isComponent: el => el.className == "CTATSkillWindow",
    model: {
      defaults: {
        traits: [
          // Strings are automatically converted to text types
          'id'
          ,{
            type:"text",
            name:'data-ctat-threshold',
            label:'Mastery Threshold'
          }
        ],
      },
    },
  });

  domc.addType('CTATSubmitButton', {
    isComponent: el => el.className == "CTATSubmitButton",
    model: {
      defaults: {
        traits: [
          // Strings are automatically converted to text types
          'id',
          {
            type:'text',
            name:'data-ctat-target',
            label:'Target ID'
          },
          {
            type: 'select', // Type of the trait
            label: 'Enabled', // The label you will see in Settings
            name: 'data-ctat-enabled', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'select', // Type of the trait
            label: 'Tutored', // The label you will see in Settings
            name: 'data-ctat-tutored', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'select', // Type of the trait
            label: 'Show Feedback', // The label you will see in Settings
            name: 'data-ctat-show-feedback', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          }, {
            type: 'select', // Type of the trait
            label: 'Disable on Correct', // The label you will see in Settings
            name: 'data-ctat-disable-on-correct', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'select', // Type of the trait
            label: 'Show Hint', // The label you will see in Settings
            name: 'data-ctat-show-hint-highlight', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          }       
        ],
      },
    },
  });

  domc.addType('CTATTable', {
    isComponent: el => el.className == "CTATTable",
    model: {
      defaults: {
        traits: [
          // Strings are automatically converted to text types
          'id'
          ,{
            type:"text",
            name:'data-ctat-num-rows',
            label:'Row Count'
          },
          {
            type:"text",
            name:'data-ctat-num-cols',
            label:'Col Count'
          },
          {
            type: 'select', // Type of the trait
            label: 'Has Header', // The label you will see in Settings
            name: 'data-ctat-has-header', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          }
        ],
      },
    },
  });


  domc.addType('CTATTextArea', {
    isComponent: el => el.className == "CTATTextArea",
    model: {
      defaults: {
        traits: [
          // Strings are automatically converted to text types
          'id',
          {
            type: 'select', // Type of the trait
            label: 'Enabled', // The label you will see in Settings
            name: 'data-ctat-enabled', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'select', // Type of the trait
            label: 'Tutored', // The label you will see in Settings
            name: 'data-ctat-tutored', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'select', // Type of the trait
            label: 'Show Feedback', // The label you will see in Settings
            name: 'data-ctat-show-feedback', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          }, {
            type: 'select', // Type of the trait
            label: 'Disable on Correct', // The label you will see in Settings
            name: 'data-ctat-disable-on-correct', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'select', // Type of the trait
            label: 'Show Hint', // The label you will see in Settings
            name: 'data-ctat-show-hint-highlight', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'select', // Type of the trait
            label: 'Tab on Center', // The label you will see in Settings
            name: 'data-ctat-tab-on-enter', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          }        
        ],
      },
    },
  });


  domc.addType('text', {
    isComponent: el => el.className == "CTATTextField",
    model: {
      defaults: {
        traits: [
          // Strings are automatically converted to text types
          'id',
          {
            type: 'select', // Type of the trait
            label: 'Enabled', // The label you will see in Settings
            name: 'data-ctat-enabled', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'select', // Type of the trait
            label: 'Tutored', // The label you will see in Settings
            name: 'data-ctat-tutored', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'select', // Type of the trait
            label: 'Show Feedback', // The label you will see in Settings
            name: 'data-ctat-show-feedback', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          }, {
            type: 'select', // Type of the trait
            label: 'Disable on Correct', // The label you will see in Settings
            name: 'data-ctat-disable-on-correct', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'select', // Type of the trait
            label: 'Show Feedback', // The label you will see in Settings
            name: 'data-ctat-show-hint-highlight', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
        ],
      },
    },
  });

  domc.addType('CTATTextInput', {
    isComponent: el => el.className == "CTATTextInput",
    model: {
      defaults: {
        traits: [
          // Strings are automatically converted to text types
          'id',
          {
            type: 'select', // Type of the trait
            label: 'Enabled', // The label you will see in Settings
            name: 'data-ctat-enabled', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'select', // Type of the trait
            label: 'Tutored', // The label you will see in Settings
            name: 'data-ctat-tutored', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'select', // Type of the trait
            label: 'Show Feedback', // The label you will see in Settings
            name: 'data-ctat-show-feedback', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          }, {
            type: 'select', // Type of the trait
            label: 'Disable on Correct', // The label you will see in Settings
            name: 'data-ctat-disable-on-correct', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'select', // Type of the trait
            label: 'Show Feedback', // The label you will see in Settings
            name: 'data-ctat-show-hint-highlight', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'select', // Type of the trait
            label: 'Has Initial Focus', // The label you will see in Settings
            name: 'autofocus', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type:'text',
            name:'maxLength',
            label:'Max Length'
          },
          {
            type:'text',
            name:'value',
            label:'Value'
          },
        ],
      },
    },
  });

  domc.addType('CTATVideo', {
    isComponent: el => el.className == "CTATVideo",
    model: {
      defaults: {
        traits: [
          // Strings are automatically converted to text types
          'id',
          {
            type:'text',
            name:'src',
            label:'Video Link'
          },

          {
            type: 'select', // Type of the trait
            label: 'Tutored', // The label you will see in Settings
            name: 'data-ctat-tutored', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
          {
            type: 'select', // Type of the trait
            label: 'Autoplay', // The label you will see in Settings
            name: 'data-ctat-autoplay', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          }, {
            type: 'select', // Type of the trait
            label: 'Show Controls', // The label you will see in Settings
            name: 'data-ctat-controls', // The name of the attribute/property to use on component
            options: [{
                id: 'true',
                name: 'True'
              },
              {
                id: 'false',
                name: 'False'
              }
            ]
          },
        ],
      },
    },
  });




};


